import { render, staticRenderFns } from "./ProductGroupList.vue?vue&type=template&id=25cc661d&scoped=true&"
import script from "./ProductGroupList.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc661d",
  null
  
)

export default component.exports